/* globals */

const HOVERED_CLASS = 'hovered';
const ACTIVE_CLASS = 'active';
const INTERACTED_ONCE_CLASS = 'interacted';
let activeOption = null;
let resetTimeout;

const colorSelector = document.getElementById('lg-cs');
let selectedColorContent;
let selectedColorTitle;
let selectedColorSupTitle;
let selectedColorDescription;
let colorLinkBtn;
let activeSupTitle;
let inactiveTitleText;

function handleMouseOver(event) {
  // Check if the hovered element or its parent is a color option
  const option = event.target.closest('.color-option');
  if (option && option !== activeOption) {
    if (activeOption) {
      activeOption.classList.remove(HOVERED_CLASS);
    }

    const dataDescription = option.getAttribute('data-description');
    const dataTitle = option.getAttribute('data-title');
    const url = option.getAttribute('href');

    selectedColorSupTitle.textContent = activeSupTitle;
    selectedColorTitle.textContent = dataTitle;

    /* restart animation */
    // if (colorSelector.classList.contains('t')) {
    //   colorSelector.classList.add('t2');
    //   colorSelector.classList.remove('t');
    // } else if (colorSelector.classList.contains('t2')) {
    //   colorSelector.classList.add('t');
    //   colorSelector.classList.remove('t2');
    // } else if (!colorSelector.classList.contains('t') && !colorSelector.classList.contains('t2')) {
    //   colorSelector.classList.add('t');
    // }

    selectedColorDescription.innerHTML = dataDescription;
    colorLinkBtn.href = url;
    // colorLinkBtn.textContent = 'Découvrir les ' + dataTitle;

    option.classList.add(HOVERED_CLASS);
    colorSelector.classList.add(ACTIVE_CLASS);
    activeOption = option;

    // clearTimeout(resetTimeout);
  }
}

export const initColorSelector = () => {
  if (colorSelector) {
    selectedColorContent = document.getElementById('lg-cs-content');
    selectedColorTitle = document.getElementById('lg-cs-title');
    inactiveTitleText = selectedColorTitle.textContent;
    selectedColorSupTitle = document.getElementById('lg-cs-title-sup');
    selectedColorDescription = document.getElementById('lg-cs-active-content');
    colorLinkBtn = document.getElementById('lg-cs-active-btn');
    activeSupTitle = selectedColorSupTitle.getAttribute('data-active-title');

    // Add a single event listener to the color selector container
    colorSelector.addEventListener('mouseover', handleMouseOver);
    colorSelector.addEventListener('touchstart', handleMouseOver);
    // colorSelector.addEventListener('mouseover', (event) => {
    //   // Check if the hovered element or its parent is a color option
    //   const option = event.target.closest('.color-option');
    //   if (option && option !== activeOption) {
    //     if (activeOption) {
    //       activeOption.classList.remove(HOVERED_CLASS);
    //     }
    //     option.classList.add(HOVERED_CLASS);
    //     selectedColorContent.classList.add('active');

    //     hoverText.textContent = option.getAttribute('data-description');

    //     // Update the button link and show it
    //     colorLinkBtn.href = option.getAttribute('href');
    //     // colorLinkBtn.style.visibility = 'visible';
    //     // colorLinkBtn.style.opacity = '1';
    //     // colorLinkBtn.style.width = '195px';
    //     // colorLinkBtn.style.paddingRight = '';
    //     // colorLinkBtn.style.paddingLeft = '';

    //     // Set this option as the active option
    //     activeOption = option;

    //     clearTimeout(resetTimeout);
    //   }
    // });

    colorSelector.addEventListener('mouseout', (event) => {
      console.warn('mouse out');
      if (activeOption) {
        activeOption.classList.remove(HOVERED_CLASS);
        colorSelector.classList.remove(ACTIVE_CLASS);
        activeOption = null;
        selectedColorSupTitle.textContent = ' '; // no-break space
        selectedColorTitle.textContent = inactiveTitleText;
      }
      // selectedColorDescription.textContent = 'Passez la souris sur une couleur pour en savoir plus.';

      // resetTimeout = window.setTimeout(() => {
      //   if (activeOption) {
      //     activeOption.classList.remove(HOVERED_CLASS);
      //     activeOption = null;
      //   }
      //   hoverText.textContent = 'Passez la souris sur une couleur pour en savoir plus.';
      // }, 4000);

      /*
    // Check if the mouse left a color option
    const option = event.target.closest('.color-option');
    if (option && option === activeOption) {
        // Keep the text updated when leaving the currently active option
        hoverText.textContent = option.getAttribute('data-description');
    } else if (!option) {
        // Reset the hover text when the mouse leaves all options
        hoverText.textContent = "Passez la souris sur une couleur pour en savoir plus.";
    }
    */
    });
  }
};
